var map = {
	"./components/layout/discussions/discussions.module": [
		"./src/app/pages/notebook/components/layout/discussions/discussions.module.ts",
		"default~components-layout-discussions-discussions-module~pages-dashboard-dashboard-module~pages-note~5dd210a9",
		"components-layout-discussions-discussions-module"
	],
	"./pages/account-management/account-management.module": [
		"./src/app/pages/account-management/account-management.module.ts",
		"pages-account-management-account-management-module"
	],
	"./pages/dashboard/dashboard.module": [
		"./src/app/pages/dashboard/dashboard.module.ts",
		"default~components-layout-discussions-discussions-module~pages-dashboard-dashboard-module~pages-note~5dd210a9",
		"default~pages-dashboard-dashboard-module~pages-notebook-notebook-module",
		"pages-dashboard-dashboard-module"
	],
	"./pages/flat-view/flat-view.module": [
		"./src/app/pages/flat-view/flat-view.module.ts",
		"pages-flat-view-flat-view-module"
	],
	"./pages/notebook/notebook.module": [
		"./src/app/pages/notebook/notebook.module.ts",
		"default~components-layout-discussions-discussions-module~pages-dashboard-dashboard-module~pages-note~5dd210a9",
		"default~pages-dashboard-dashboard-module~pages-notebook-notebook-module",
		"pages-notebook-notebook-module"
	],
	"./pages/onboarding/onboarding.module": [
		"./src/app/pages/onboarding/onboarding.module.ts",
		"pages-onboarding-onboarding-module"
	],
	"./pages/shares/shared-note/shared-note.module": [
		"./src/app/pages/shares/shared-note/shared-note.module.ts",
		"pages-shares-shared-note-shared-note-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;